import { EmployeeDisplayData, EmployeeDisplayDataByAlias } from './types';
import { DOCUMENTS } from './model';

const childrenAlias: Dictionary<any> = {
  Son: 'Son',
  Daughter: 'Daughter',
};

export const splitFamily = (family: any[] = []) => {
  const familyData: any[] = family || [];

  const data = {
    children: [],
    other: [],
  };

  familyData.forEach(member => {
    if (childrenAlias[member.relation]) {
      data.children.push(member as never);
    } else {
      data.other.push(member as never);
    }
  });

  return data;
};

export const mapSortingParameters = (parameters: { [s: string]: unknown } | ArrayLike<unknown>) => {
  const result: Dictionary<any> = {};

  Object.entries(parameters).forEach(([sortBy, sortOrder]) => {
    switch (sortBy) {
      case 'fullName': {
        result['nameEn.lastName'] = sortOrder;
        result['nameEn.firstName'] = sortOrder;
        break;
      }
      case 'positionName': {
        result['position.name'] = sortOrder;
        break;
      }
      case 'email': {
        result.workingEmail = sortOrder;
        break;
      }
      case 'employeeId': {
        result.alias = sortOrder;
        break;
      }
      default: {
        result[sortBy] = sortOrder;
      }
    }
  });

  return result;
};

export const mapSearchFilters = (filters: Dictionary<any> = {}) => {
  const filterByCommonSkillExperience = filters['specification:commonSkillExperience'];

  const newFilters: Dictionary<any> = {
    archivedStatus: {
      eq: 'ACTIVE',
    },
    ...filters,
  };

  if (filterByCommonSkillExperience) {
    const filterByCommonSkillExperienceDuration = filters['specification:commonSkillExperience.experienceDuration'];
    if (filterByCommonSkillExperienceDuration) {
      delete newFilters['specification:commonSkillExperience.experienceDuration'];
    }

    newFilters[`specification:commonSkillExperience`] = {
      in: {
        commonSkillId: filterByCommonSkillExperience?.in[0],
        experienceDuration: filterByCommonSkillExperienceDuration?.in,
      },
    };
  }

  return newFilters;
};

export const getIdentityDocumentNumber = (employeeData: { extendedInformation: { identityDocuments: any } }) => {
  const identityDocuments = employeeData?.extendedInformation?.identityDocuments;
  const documentTypes = Object.keys(DOCUMENTS);

  const document = documentTypes
    .map(type => identityDocuments?.find((doc: { type: string }) => doc.type === type))
    .find(doc => doc);

  return document ? document.number : null;
};

export const indexEmployeeDisplayDataByAlias = (
  employeeNames: Array<Pick<EmployeeDisplayData, 'alias' | 'nameEn'>>,
  contractors: Array<Pick<EmployeeDisplayData, 'alias' | 'contractCountry'>>,
): EmployeeDisplayDataByAlias => {
  const employeeDisplayDataByAlias = employeeNames.reduce<EmployeeDisplayDataByAlias>((acc, employeeName) => {
    if (!employeeName.alias) {
      return acc;
    }

    acc[employeeName.alias] = {
      ...acc[employeeName.alias],
      ...employeeName,
    };

    return acc;
  }, {});

  return contractors.reduce<EmployeeDisplayDataByAlias>((acc, contractor) => {
    if (!contractor.alias) {
      return acc;
    }

    acc[contractor.alias] = {
      ...acc[contractor.alias],
      ...contractor,
      isContractor: true,
    };

    return acc;
  }, employeeDisplayDataByAlias);
};
